import { api } from '@services/Api'
import queryString from 'query-string';
import { decode } from 'html-entities';
import { Options, Pagination, Image } from '@lib/types';

export interface Result {
  id: number;
  name: string;
  slug: string;
  taxonomy: string;
  description: string;
  hasNewPosts: boolean;
  color: string;
  link: string;
  count: number;
  image: Image;
}

export interface RootObject {
  success: number;
  results: Result[];
  options: Options[];
  pagination: Pagination;
}

export const transformTaxResponse = (responseData: RootObject) => {

  const results = responseData.results
    ?.map(item => {
      return {
        id: item.id,
        title: item.name,
        date: null,
        description: item.description,
        image: item.image,
        hasBadge: item.hasNewPosts,
        backgroundColor: item.color,
        link: {
          url: item.link,
          title: "Read More",
          target: '_self'
        }
      }
    });

  const options = responseData.results
    ?.map(item => {
      return {
        value: item.id,
        label: `${decode(item.name)} (${item.count})` ,
      }
    });

  return {
    results,
    options,
    pagination: responseData.pagination,
  };
};


const postApi = api.injectEndpoints({
  endpoints: (build) => ({
    getTaxonomies: build.query({
      query: (params) => {
        return {
          url: `/covr/v1/taxonomies/?${queryString.stringify(
            params, {
            arrayFormat: 'comma'
          }
          )}`,
          method: "GET",
        };
      },
      providesTags: [],
      transformResponse: transformTaxResponse,
    }),
  })
});

export const {
  useGetTaxonomiesQuery,
} = postApi;
